import { lazy } from 'react'

export const PaymentVariant7 = lazy(() => import('./PaymentVariant7'))
